const defaultFont = [
  {label: "方正黑体", value: '2018-5-16/1526467728442.TTF', payType: 0, status: 2, fontUrl: "2019-1-16/e0e87a2b-633f-412f-930e-856e9afbbc79nail.png"},
  {label: "站酷快乐体", value: '2017-7-20/1500533164316.ttf', payType: 0, status: 2, fontUrl: "2019-1-19/a5a1e8a2-e2ad-49c8-ae71-b4225bdf04fanail.png"}
]

const state = {
  downFonts: [].concat(defaultFont),
  brandList: [],
  textOption: {
    title: {
      text: "添加标题",
      fontId: "e629e28b-df72-4767-a6d3-695c50c841e7",
      font: {
        fontSize: 80,
        color: "#303233",
        fontWeight: "bold",
        fontFamilyUrl: "2018-5-16/1526467728442.TTF",
        textAlign: "center"
      }
    },
    subtitle: {
      text: "添加副标题",
      fontId: "e629e28b-df72-4767-a6d3-695c50c841e7",
      font: {
        fontSize: 65,
        color: "#303233",
        fontWeight: "bold",
        fontFamilyUrl: "2018-5-16/1526467728442.TTF",
        textAlign: "center"
      }
    },
    content: {
      text: "添加正文",
      fontId: "e629e28b-df72-4767-a6d3-695c50c841e7",
      font: {
        fontSize: 50,
        color: "#303233",
        fontWeight: "normal",
        fontFamilyUrl: "2018-5-16/1526467728442.TTF",
        textAlign: "center"
      }
    }
  }
}

const getters = {
  downFonts: state => state.downFonts,
  brandList: state => state.brandList,
  textOption: state => state.textOption
}

const mutations = {
  toggle_downFonts (state, data) {
    state.downFonts = data ? data : [].concat(defaultFont)
  },
  toggle_brandList (state, data) {
    state.brandList = data ? data : []
  },
  toggle_textOption (state, data) {
    if(!data) return;
    state.textOption = $.extend(true, state.textOption, data)
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/fontList.js